import { makeObservable, observable } from 'mobx'
import { Board } from '../pages/board/Board.type'
import RootStore from './RootStore'

const BOARD_URL = 'https://static.kdac.io/board/board.json'

export class BoardStore {
  rootStore: RootStore
  boards: Board[] = []
  boardMap: Record<number, Board> = {}
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeObservable(this, {
      boards: observable,
      boardMap: observable,
    })
  }
  async load() {
    let data = [] as Board[]
    try {
      data = await fetch(BOARD_URL).then((r) => r.json())
    } catch (e) {
      // do nothing
    }
    this.boards = data.sort((a, b) => a.order - b.order)
    this.boardMap = {}
    this.boards.forEach((board) => {
      this.boardMap[board.id] = board
    })
    return this.boards
  }

  getBoard(id: number) {
    const board = this.boardMap[id]
    if (board == null) {
      return null
    }
    if (board.createTime == null) {
      board.createTime = ''
    } //
    else {
      const d = new Date(board.createTime)
      if (!isNaN(d.getTime())) {
        board.createTime = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d
          .getDate()
          .toString()
          .padStart(2, '0')}`
      }
    }
    return board
  }
  getPartition(limit: number = 6) {
    const boards = this.boards.slice(0, limit)
    const spacing = 2
    const partition = []
    for (let i = 0; i < boards.length; i += spacing) {
      partition[partition.length] = boards.slice(i, i + spacing)
    }
    return partition
  }
}
